/** Canonical plan copy — HIR-1326 / HIR-449 v6.3.3 */

export type ProBillingInterval = 'monthly' | 'annual'

export const SUBSCRIPTION_LEDE =
  'Compare plans in one place — what you get, how many optimizations, and when you pay.'

export const SUBSCRIPTION_FOOTNOTE =
  'Pricing v6.3.3 (HIR-49) · Annual Pro shows ~$14/mo when toggle is on'

export const FREE_PLAN_BENEFITS = [
  '10 resume optimizations for the life of your account',
  'Edit, preview, and export PDF anytime',
  'See match score before you upgrade',
  'Buy a +5 pack without subscribing',
] as const

export const PRO_MONTHLY_BENEFITS = [
  { text: '100 optimizations', emphasis: true, suffix: ' every billing month' },
  { text: 'Tailor each resume to a specific job description', emphasis: false },
  { text: 'Wallet credits for +5 packs roll with your account', emphasis: false },
  { text: 'Priority path when you apply to many roles', emphasis: false },
] as const

export const PRO_ANNUAL_BENEFITS = [
  { text: '150 optimizations', emphasis: true, suffix: ' every billing month' },
  { text: 'Tailor each resume to a specific job description', emphasis: false },
  { text: 'Wallet credits for +5 packs roll with your account', emphasis: false },
  { text: 'Priority path when you apply to many roles', emphasis: false },
] as const

export const PRO_TRY_BENEFITS = [
  { text: '20 optimizations', emphasis: true, suffix: ' in 7 days' },
  { text: 'Full Pro tailoring for an intensive search week', emphasis: false },
  { text: 'Switch to monthly Pro when the week ends', emphasis: false },
] as const

export const OVERAGE_PACK_BENEFITS = [
  { text: '5 extra optimizations', emphasis: true, suffix: ' without upgrading' },
  { text: 'Use on Free or Pro when you hit the cap', emphasis: false },
  { text: 'Same checkout as the editor paywall', emphasis: false },
] as const

export const OVERAGE_LINK_LABEL = 'Need more this month? Get 5 for $5'

export function proPriceDisplay(interval: ProBillingInterval): {
  headline: string
  subline: string
  checkoutPlan: 'pro_monthly' | 'pro_annual'
} {
  if (interval === 'annual') {
    return {
      headline: '~$14',
      subline: '$168 billed annually · cancel anytime',
      checkoutPlan: 'pro_annual',
    }
  }
  return {
    headline: '$20',
    subline: 'Billed monthly · cancel anytime',
    checkoutPlan: 'pro_monthly',
  }
}
